<td-wb-empty class="td-wb-w8ben-form-error">
  <td-wb-icon class="td-wb-w8ben-form-error__icon"
              tdWbEmptyIcon
              iconId="circle-error"
              size="60" />
  <td-wb-empty-header class="td-wb-w8ben-form-error__title" translate="tdWb.w8BenForm.modal.error.HEADER" />
  <td-wb-empty-sub-header id="td-wb-w8ben-form-error-description">
    @if (submitError()) {
      <span translate="tdWb.w8BenForm.modal.error.DESCRIPTION_SUBMIT"></span>
    } @else {
      <span translate="tdWb.w8BenForm.modal.error.DESCRIPTION_I"></span>
    }
    <div translate="tdWb.w8BenForm.modal.error.DESCRIPTION_II"></div>
  </td-wb-empty-sub-header>
</td-wb-empty>
